export const Options = {
    Handicap: [
        {text:"Ja",value:"-1"},
        {text:"Nein",value:"0"}
    ]
}
